/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { DeferredBaseCheckoutState } from './deferred-base-checkout-state';
import {
    ICheckoutState,
    IGlobalState,
    GlobalStateType,
    GlobalStateConstructor,
    GlobalStateInput,
    getState
} from '@msdyn365-commerce/global-state';
import { IObservableAction, createObservableDataAction, IAction, ICreateActionContext } from '@msdyn365-commerce/core';

function createGlobalStateDataAction<TOut extends IGlobalState>(
    key: GlobalStateType,
    stateConstructor: GlobalStateConstructor<TOut>
): IObservableAction<TOut> {
    return createObservableDataAction({
        action: <IAction<TOut>>getState,
        input: (args: ICreateActionContext) => {
            return new GlobalStateInput(key, stateConstructor, args.requestContext.apiSettings, args.requestContext);
        }
    });
}

export default createGlobalStateDataAction<ICheckoutState>('CHECKOUTSTATE', DeferredBaseCheckoutState);
